/* eslint-disable react/destructuring-assignment */
/* global $ */
import React from 'react'
import apiClient from 'services/api'
import { Button } from 'reactstrap'
import { isObject } from 'lodash'
import { AddIcon, EditIcon } from '../../../../config/icons'
import { getIris, isEmpty } from '../../utils'

const isResource = value => isObject(value) && (value['@id'] || value.id)

export default class JAutocomplete extends React.Component {
  currentValue = null

  hasJustSelected = false

  static defaultProps = {
    getValue: null,
    filter: 'filter',
    valueKey: '@id',
    valueLabel: 'label',
    useIris: true,
    field: {},
    getInitialValue: null
  }


  constructor(props) {
    super(props)
    this.currentValue = props.field.value
    this.state = {
      label: this.props.field.value || '',
    }
  }

  componentDidMount() {
    const { options, source, useIris, params, minLength = 0, containerClassName } = this.props
    const field = $(this.input)

    this._reInit({ useIris, source, field: this.props.field })

    // Se abbiamo containerClassName scrollable-dropdown, appendiamo al parent container
    const appendTo = containerClassName === 'scrollable-dropdown' ? $(this.input).parent() : this.props.appendTo

    const isSourceFunction = typeof source === 'function';

    field
      .autocomplete({
        minLength,
        appendTo,
        source: isSourceFunction
          ? (request, response) => source(request, items => response(items.map(this._getItemValues)))
          : (request, response) => {
              const encodedFilterValue = encodeURIComponent(request.term);
              apiClient
                .get(source, {
                  params: {
                    [this.props.filter]: encodedFilterValue,
                    ...params,
                  },
                })
                .then(({ data }) => {
                  const items = data['@context'] ? data['hydra:member'] : data;
                  response(items.map(this._getItemValues));
                });
            },
        select: (event, ui) => {
          this.hasJustSelected = true
          this.setState({ label: ui && ui.item ? ui.item.label : '' }, () => {
            this.currentValue = ui.item?.id || ui.item?.value || null
            this._onChange(ui.item)
          })
        },
        change: (event, ui) => {
          if (ui.item == null) {
            if (this.hasJustSelected) {
              this.hasJustSelected = false
              return
            }
            this.setState({ label: '' }, () => {
              this.currentValue = null
              this._onChange(null)
            })
          }
        },
        ...options,
      })
      
    // Se abbiamo containerClassName scrollable-dropdown, aggiungiamo la classe al dropdown
    if (containerClassName === 'scrollable-dropdown') {
      // Aggiungiamo un attributo data al campo input per identificarlo
      field.attr('data-scrollable-dropdown', 'true')
      
      field.on('autocompleteopen', () => {
        const dropdown = field.autocomplete('widget')
        dropdown.addClass('scrollable-autocomplete')
        dropdown.attr('data-scrollable-dropdown', 'true')
      })
      
      field.on('autocompleteclose', () => {
        const dropdown = field.autocomplete('widget')
        dropdown.removeClass('scrollable-autocomplete')
        dropdown.removeAttr('data-scrollable-dropdown')
      })
    }
    
    if (minLength === 0) {
      field.click(() => field.autocomplete('search'))
    }

    field.blur(() => {
      if (field.val().trim() === '') {
        this.currentValue = null
        this._onChange(null)
      }
    })
  }

  componentDidUpdate() {
    // console.log("componentDidUpdate", props.field.value, this.props.field.value, this.currentValue)
    if (this.props.field.value !== this.currentValue) {
      this.currentValue = this.props.field.value
      this._reInit({ useIris: this.props.useIris, source: this.props.source, field: this.props.field })
    }
  }

  setLabel(label) {
    this.setState({ label })
  }

  _reInit = ({ useIris, source, field }) => {
    if ((useIris && field.value) || !isEmpty(field.value)) {

      const valueIsResource = isResource(field.value)

      let url = useIris ? field.value : `${source}/${field.value}`

      if (valueIsResource) {
        url = getIris(field.value)
      }

      if (this.props.getInitialValue) {
        this.props.getInitialValue(field.value).then((data) => {
          this.setState({
            label: this._getLabelValue(data),
          })
        }).catch(() => {
          this.setState({
            label: `Not found id: ${field.value}`,
          })
        })
      } else {
        apiClient
          .get(url)
          .then(response => {
            this.setState({
              label: this._getLabelValue(response.data),
            })
          })
          .catch(() => {
            this.setState({
              label: `Not found id: ${field.value}`,
            })
          })
      }


    }
  }

  _getItemValues = i => {
    const itemId = i[this.props.valueKey || 'id']
    return {
      ...i,
      id: itemId,
      // jQuery UI autocomplete expects `value`; keeping it explicit avoids losing custom props.
      value: itemId,
      label: this._getLabelValue(i),
    }
  }

  _onChange = item => {
    if (this.props.onChange) {
      return this.props.onChange(item)
    }
    if (this.props.setValues) {
      return this.props.form.setValues({
        ...this.props.form.values,
        ...this.props.setValues(item),
      })
    }
    return this.props.form.setFieldValue(this.props.field.name, item ? item.id : null)
  }

  _getLabelValue = i => {
    if (this.props.getLabel) {
      return this.props.getLabel(i)
    }
    return i[this.props.valueLabel] || i.label
    // return `${i.first_name} ${i.last_name}`
  }

  clearLabel() {
    this.setState({ label: '' })
  }

  render() {
    const {
      placeholder,
      style,
      onEditClick,
      onAddClick,
      renderButtons,
      disabled = false,
      containerClassName = '',
    } = this.props

    return (
      <div style={{ display: 'flex', flexDirection: 'row' }} className={containerClassName}>
        <input
          style={style}
          placeholder={placeholder}
          disabled={disabled}
          className={'form-control input-sm'}
          onChange={({ target }) => {
            this.hasJustSelected = false
            this.setState({ label: target.value })
          }}
          value={this.state.label}
          ref={input => {
            this.input = input
          }}
        />
        {onEditClick && (
          <Button color={'primary'}>
            <EditIcon />
          </Button>
        )}
        {onAddClick && (
          <Button color={'outline-primary'}>
            <AddIcon />
          </Button>
        )}
        {renderButtons && renderButtons({ value: this.props.field.value })}
      </div>
    )
  }
}
